import React from 'react'
import { gql, graphql } from 'react-apollo'

import {
  Notifications,
  Loading,
} from 'components/UI'
import UserTable from './UserTable'


const AdminUserList = ({ data }) => {
  const {
    error,
    loading,
    managers,
    superintendents,
    refetch,
  } = data

  if (error) return <Notifications.Error message={error.message} />
  if (loading) return <Loading />

  // Merge the localAdmins and users arrays.
  // A prefix is added to the IDs to make sure they are
  // unique in the final merged array.
  const localAdmins = managers.map(({ id, ...rest }) => ({
    role: 'Manager',
    key: `localAdmin${id}`,
    id,
    ...rest,
  }))
  const users = superintendents.map(({ id, ...rest }) => ({
    role: 'Superintendent',
    key: `user${id}`,
    id,
    ...rest,
  }))
  const usersData = localAdmins.concat(users)

  return (
    <UserTable
      data={usersData}
      refetch={refetch}
    />
  )
}

const AdminUserListQuery = gql`
  query AdminUserListQuery {
    managers {
      id
      givenName
      familyName
      email
      organization {
        name
        buildings {
          id
        }
      }
    }
    superintendents {
      id
      givenName
      familyName
      email
      buildings {
        id
      }
    }
  }
`

export default graphql(AdminUserListQuery, {
  options: {
    notifyOnNetworkStatusChange: true,
  },
})(AdminUserList)



// WEBPACK FOOTER //
// ./src/components/Profile/AdminUserList.jsx